import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NjDialog',
  props: {
    model: { type: Boolean, default: false },
    maxWidth: { default: 290 },
    minHeight: { default: 100 }
  },
  emits: ["dialog-changed"],
  setup(__props: any, { emit }) {

const props = __props as { model: boolean, maxWidth: number | string, minHeight: number | string };




const { model, maxWidth, minHeight } = toRefs(props);
const _model = computed<boolean>({
  get: () => model.value,
  set: (newValue: boolean) => {
    emit("dialog-changed", newValue);
  },
});

return { __sfc: true,emit, props, model, maxWidth, minHeight, _model }
}

})